<template>
  <div>
    <Head title="後台帳號管理" />
    <ScrollTop />

    <Breadcrumb :home="breadcrumb_home" :model="breadcrumb_paths" />

    <Dialog :visible.sync="showAddDialog" :modal="true">
      <form autocomplete="off">
        <div class="mb-2 flex flex-row items-center">
          <SelectButton
            v-model="add.level"
            :options="levels"
            optionLabel="name"
            optionValue="level"
          />
        </div>

        <div class="mb-2 flex flex-row items-center">
          <label class="w-20" for="name">姓名</label>
          <InputText class="basis-1/5" id="name" v-model="add.name" />
        </div>

        <div class="mb-2 flex flex-row items-center">
          <label class="w-20" for="mobile">行動電話</label>
          <InputText id="mobile" v-model="add.mobile" />
        </div>

        <div class="mb-2 flex flex-row items-center">
          <label class="w-20" for="email">電子郵件</label>
          <InputText id="email" v-model="add.email" />
        </div>

        <div class="mb-2 flex flex-row items-center">
          <label class="w-20" for="password">密碼</label>
          <Password id="password" v-model="add.password" toggleMask />
        </div>

        <div class="mt-5 text-right">
          <Button label="新增" @click="addAdmin" />
        </div>
      </form>
    </Dialog>

    <Dialog :visible.sync="showEditDialog" :modal="true">
      <form autocomplete="off">
        <div class="mb-2 flex flex-row items-center">
          <SelectButton
            v-model="edit.level"
            :options="levels"
            optionLabel="name"
            optionValue="level"
            :disabled="$page.props.current_admin.level < 30"
          />
        </div>

        <div class="mb-2 flex flex-row items-center">
          <label class="w-20" for="name">姓名</label>
          <InputText class="basis-1/5" id="name" v-model="edit.name" />
        </div>

        <div class="mb-2 flex flex-row items-center">
          <label class="w-20" for="mobile">行動電話</label>
          <InputText id="mobile" v-model="edit.mobile" />
        </div>

        <div class="mb-2 flex flex-row items-center">
          <label class="w-20" for="email">電子郵件</label>
          <InputText id="email" v-model="edit.email" />
        </div>

        <div class="mt-5 text-right">
          <Button label="編輯" @click="editAdmin" />
        </div>
      </form>
    </Dialog>

    <Dialog :visible.sync="showChangePasswordDialog" :modal="true">
      <div class="mb-2 flex flex-row items-center">
        <label class="w-20" for="password">密碼</label>
        <Password id="password" v-model="change.password" toggleMask />
      </div>

      <div class="mt-5 text-right">
        <Button label="變更密碼" @click="changePassword" />
      </div>
    </Dialog>

    <!-- :selection.sync="selectedAdmins"
      sortMode="multiple" -->
    <DataTable
      :value="admins.data"
      :multiSortMeta.sync="multiSortMeta"
      @sort="onSort($event)"
    >
      <template #header>
        <div class="text-right">
          <Button
            label="新增管理員"
            @click="showAddDialog = true"
            :disabled="$page.props.current_admin.level < 30"
          />
        </div>
        <!-- </div> -->
      </template>

      <!-- <Column headerClass="w-11" selectionMode="multiple"></Column> -->
      <Column header="姓名" field="name" sortable></Column>
      <Column header="手機" field="mobile" sortable></Column>
      <Column header="電子郵件" field="email" sortable></Column>
      <Column header="類型" field="level" sortable>
        <template #body="slotProps">
          <template v-if="slotProps.data.level == 100">神</template>
          <template v-else-if="slotProps.data.level >= 30">系統管理員</template>
          <template v-else-if="slotProps.data.level >= 20">高級管理員</template>
          <template v-else-if="slotProps.data.level >= 10">系統操作員</template>
          <template v-else>作業員</template>
        </template>
      </Column>
      <Column headerClass="w-40" header="動作">
        <template #body="slotProps">
          <SplitButton
            label="編輯"
            :model="splitButonFunction(slotProps.data)"
            @click="showEditAdmin(slotProps.data)"
          ></SplitButton>
        </template>
      </Column>
    </DataTable>

    <div class="w-full mt-10 flex justify-around">
      <Paginator :page-data="$page.props.admins" />
    </div>
  </div>
</template>

<script>
import Layout from "../Layout";
import ScrollTop from "primevue/scrolltop";
import Breadcrumb from "@/Shared/Components/Breadcrumb";
import Dropdown from "primevue/dropdown";
import Dialog from "primevue/dialog";
import InputText from "primevue/inputtext";
import Password from "primevue/password";
import SelectButton from "primevue/selectbutton";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Button from "primevue/button";
import SplitButton from "primevue/splitbutton";
import Paginator from "@/Shared/Paginator";

export default {
  layout: Layout,
  components: {
    ScrollTop,
    Breadcrumb,
    Dialog,
    InputText,
    Password,
    SelectButton,
    Dropdown,
    DataTable,
    Column,
    Button,
    SplitButton,

    Paginator,
  },
  props: {
    admins: Object,
    current_admin: Object,
  },
  data() {
    return {
      breadcrumb_home: {
        label: "後台管理",
        disabled: true,
      },
      breadcrumb_paths: [
        {
          label: "後台帳號管理",
          disabled: true,
        },
      ],
      levels: [
        {
          level: 30,
          name: "系統管理員",
        },
        {
          level: 20,
          name: "高階管理員",
        },
        {
          level: 10,
          name: "系統操作員",
        },
        {
          level: 0,
          name: "作業員",
        },
      ],
      add: {
        name: null,
        mobile: null,
        email: null,
        level: 30,
        password: null,
      },
      edit: {
        name: null,
        mobile: null,
        email: null,
        level: 30,
        password: null,
      },
      change: {
        password: null,
      },
      filterables: [],
      selectedFilters: [],
      selectedAdmins: [],
      multiSortMeta: [],
      search: null,
      showAddDialog: false,
      showEditDialog: false,
      showChangePasswordDialog: false,
    };
  },
  methods: {
    changePassword() {
      this.$inertia.patch(
        route("admin.admins.patch", this.change.id) +
          "?from=" +
          encodeURIComponent(this.$page.url),
        { password: this.change.password },
        {
          preserveScroll: true,
          preserveState: true,
          only: ["admins"],
          onSuccess: (page) => {
            this.showChangePasswordDialog = false;
          },
        }
      );
    },
    showChangePassword(item) {
      this.change = {
        id: item.id,
        password: null,
      };

      this.showChangePasswordDialog = true;
    },
    showEditAdmin(item) {
      this.edit = item;
      this.showEditDialog = true;
    },
    splitButonFunction(item) {
      return [
        {
          label: "變更密碼",
          command: () => {
            this.showChangePassword(item.id);
          },
        },
        {
          label: "刪除",
          disabled: this.$page.props.current_admin.level < 30,
          command: () => {
            this.deleteAdmin(item.id);
          },
        },
      ];
    },
    showAddAdmin() {
      this.add = {
        name: null,
        mobile: null,
        email: null,
        level: 30,
        password: null,
      };

      this.showAddDialog = true;
    },
    addAdmin() {
      this.$inertia.post(route("admin.admins"), this.add, {
        preserveScroll: true,
        preserveState: true,
        only: ["admins"],
        onSuccess: (page) => {
          this.showAddDialog = false;
        },
      });
    },
    editAdmin() {
      this.$inertia.patch(
        route("admin.admins.patch", this.edit.id) +
          "?from=" +
          encodeURIComponent(this.$page.url),
        {
          name: this.edit.name,
          mobile: this.edit.mobile,
          email: this.edit.email,
          level: this.edit.level,
        },
        {
          preserveScroll: true,
          preserveState: true,
          only: ["admins"],
          onSuccess: (page) => {
            this.showEditDialog = false;
          },
        }
      );
    },
    deleteAdmin(id) {
      this.$confirm.require({
        message: "是否確認刪除？",
        header: "刪除確認",
        acceptLabel: "確認刪除",
        rejectLabel: "不要刪除",
        accept: () => {
          this.$inertia.delete(
            route("admin.admins.delete", id) +
              "?from=" +
              encodeURIComponent(this.$page.url),
            {
              preserveScroll: true,
              preserveState: true,
              only: ["admins"],
            }
          );
        },
        reject: () => {
          //
        },
      });
    },
    getQueryStrings() {
      let queryStr = window.location.search,
        queryArr = queryStr.replace("?", "").split("&"),
        queryParams = [];

      for (let q = 0, qArrLength = queryArr.length; q < qArrLength; q++) {
        let qArr = queryArr[q].split("=");
        queryParams[qArr[0]] = qArr[1];
      }

      return _(queryParams).omitBy(_.isUndefined).omitBy(_.isNull).value();
    },
    onSearch: _.debounce(function () {
      this.selectedOrders = [];

      let queryStringArray = this.getQueryStrings();

      queryStringArray["search"] = this.search;

      let queryStrings = [];

      _.forIn(queryStringArray, (value, key) => {
        queryStrings.push(key + "=" + value);
      });

      let url = this.$page.url.split("?")[0] + "?" + queryStrings.join("&");

      this.$inertia.visit(url, {
        preserveScroll: true,
        preserveState: true,
        only: ["merchandises"],
      });
    }, 1000),
    onSort(event) {
      this.selectedOrders = [];

      let queryStringArray = this.getQueryStrings();

      queryStringArray["sort"] = JSON.stringify(event.multiSortMeta);

      let queryStrings = [];

      _.forIn(queryStringArray, (value, key) => {
        queryStrings.push(key + "=" + value);
      });

      let url = this.$page.url.split("?")[0] + "?" + queryStrings.join("&");

      this.$inertia.visit(url, {
        preserveScroll: true,
        preserveState: true,
        only: ["admins"],
      });
    },
    onFilter(event) {
      this.selectedOrders = [];

      let queryStringArray = this.getQueryStrings();

      queryStringArray["filter"] = JSON.stringify(event.value);

      let queryStrings = [];

      _.forIn(queryStringArray, (value, key) => {
        queryStrings.push(key + "=" + value);
      });

      let url = this.$page.url.split("?")[0] + "?" + queryStrings.join("&");

      this.$inertia.visit(url, {
        preserveScroll: true,
        preserveState: true,
        only: ["merchandises"],
      });
    },
  },
  mounted() {
    if (this.getQueryStrings()["sort"]) {
      this.multiSortMeta = JSON.parse(
        decodeURI(this.getQueryStrings()["sort"])
      );
    }

    if (this.getQueryStrings()["search"]) {
      this.search = decodeURI(this.getQueryStrings()["search"]);
    }

    if (this.getQueryStrings()["filter"]) {
      let selected = JSON.parse(decodeURI(this.getQueryStrings()["filter"]));

      _.forIn(this.filterables, (item) => {
        let found = _.find(selected, item.condition);
        if (found) {
          this.selectedFilters.push(found);
        }
      });
    }
  },
};
</script>

<style lang="postcss">
.p-breadcrumb {
  @apply border-0;
}
</style>